import React from 'react';
import ProductCarousel from './ProductCarousel';

const CategorySection = ({ id, eyebrow, title, description, ctaText, ctaLink, products, onAdd, viewAllLink, viewAllText, banner, showCustomDesign = false }) => {
  return (
    <section id={id} className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4">
        {/* Banner block on top, like virtuoso */}
        {banner && (
          <div
            className="relative rounded-sm overflow-hidden mb-10 aspect-[16/5] md:aspect-[16/4] bg-gray-200"
            style={{
              backgroundImage: `url(${banner})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent" />
            <div className="absolute inset-0 flex items-center">
              <div className="px-6 md:px-14 max-w-xl text-white">
                <h2 className="text-2xl md:text-4xl font-bold leading-tight mb-3" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
                  {title}
                </h2>
                <p className="text-sm md:text-base mb-5 opacity-95">{description}</p>
                <a
                  href={ctaLink || '#'}
                  className="inline-block bg-white text-gray-900 hover:bg-amber-500 hover:text-white font-semibold px-6 py-2.5 text-sm uppercase tracking-wide rounded-sm transition-colors"
                >
                  {ctaText || 'Descoperă'}
                </a>
              </div>
            </div>
          </div>
        )}

        <div className="flex items-end justify-between mb-2 gap-4">
          <div>
            {eyebrow && (
              <div className="text-amber-600 text-xs uppercase tracking-[0.3em] font-semibold mb-2">{eyebrow}</div>
            )}
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
              {title}
            </h3>
          </div>
        </div>
        {description && !banner && (
          <p className="text-gray-600 max-w-3xl mb-8">{description}</p>
        )}
        {banner && (
          <p className="text-gray-600 max-w-3xl mb-8 mt-3">{description}</p>
        )}

        <ProductCarousel products={products} onAdd={onAdd} showCustomDesign={showCustomDesign} />

        {viewAllLink && (
          <div className="mt-8 text-right">
            <a
              href={viewAllLink}
              className="inline-flex items-center gap-1 text-sm font-semibold text-gray-900 hover:text-amber-600 transition-colors border-b-2 border-transparent hover:border-amber-600 pb-1"
            >
              {viewAllText} &gt;
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default CategorySection;
